module.exports = __webpack_public_path__ + "static/media/nike-oranje-fatalis-4.868ac2f2.jpg";